
<template>
  <b-card no-body class="wrapper">
    <!-- <template v-slot:header>
      <h4>Main Contact</h4>
    </template> -->

    <b-card-body>
      <b-card-text>
        <div class="label">Transfer Code</div>
        <div class="text">{{ companyId }}</div>

        <b-alert variant="warning" show>
          <font-awesome-icon icon="exclamation-triangle" />
          Please ensure you have saved all your changes to the company before
          transferring
        </b-alert>

        <div class="text">
          <b-button class="mt-3" variant="success" block @click="saveStatus">
            <font-awesome-icon icon="check" /> Confirm
          </b-button>

          <b-button class="mt-3" variant="danger" block @click="$parent.showDispositions">
            <font-awesome-icon icon="times" /> Cancel
          </b-button>
        </div>
      </b-card-text>
    </b-card-body>
  </b-card>
</template>

<script>
import DataSelectionService from "@/services/DataSelection.service";

export default {
  name: "CompanyTransferCreate",
  props: {
    companyId: String,
  },

  methods: {

    saveStatus() {
      this.isBusy = true;

      this.$http.post("/company/savetransfer/" + this.companyId).then(() => {
        if(this.$route.name == "CompanyCall") {
            DataSelectionService.getNextCompany().then(result => {
              if(result && result.data != 0) {
               this.$router.push("/call/" + result.data);
              } else {
                this.$router.push("/getnext");
              }
            });
          } else {
            this.isBusy = false;
            this.$parent.showDispositions();
          }
      });
    },
  },
};
</script>

<style scoped>
.label {
  font-weight: 600;
}
.text {
  margin-bottom: 10px;
}
.wrapper {
  margin-top: 10px;
}
</style>
